import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { BaseProps } from "../../utils/baseProps"

const GwarancjaRabatuImage: React.FC<BaseProps> = ({ className }) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "gwarancja-rabatu.png" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      alt="gwarancja_rabatu"
      className={className}
      fluid={data.placeholderImage.childImageSharp.fluid}
      imgStyle={{
        objectPosition: "bottom",
      }}
    />
  )
}

export default GwarancjaRabatuImage
